export const usePromotionPage = async () => {
  const nuxtApp = useNuxtApp()
  const {
    asyncCategory,
    breadcrumbs,
    items: promotions,
    page,
    perPage,
    total,
  } = await useListApi<Promotion>({
    itemPath: '/promotions?populate=productCategory&orderBy=position&sortBy=asc',
    componentName: 'Promotion',
    hasCategory: false,
    defaultPerPage: 24,
  })

  const { getPath, slugPageInfo, domain } = useNavigationMenu()
  const { isMainLanguage } = useLanguage()

  useCustomSeo({
    title: () => slugPageInfo.value?.metaTitleFront,
    description: () => slugPageInfo.value?.metaDescriptionFront || slugPageInfo.value?.description,
    image: () => slugPageInfo.value?.ogImage?.large,
    noindex: () => !isMainLanguage.value && promotions.value.length === 0,
  })

  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const eventPromotion = (promotion: string) => {
    analyticEvent({
      ga4ActionName: 'click_promotion',
      ga4Label: promotion,
    })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: 'Promotion',
      fbValue: { label: promotion },
    })
  }

  const { currentLocaleCode } = useLanguage()
  const currencyStore = useCurrencyStore()
  const currencyName = computed(() => currencyStore.currentName)
  nuxtApp.runWithContext(() => useSchemaOrg([
    defineWebPage({
      '@type': 'CreativeWork',
      name: slugPageInfo.value?.metaTitleFront,
      '@id': `${domain.value}${getPath({ componentName: 'Promotion' })}#webpage`,
      url: `${domain.value}${getPath({ componentName: 'Promotion' })}`,
      inLanguage: currentLocaleCode.value,
      isPartOf: { '@id': `${domain.value}/#website` },
      publisher: { '@id': `${domain.value}/#organization` },
      mainEntity: promotions.value.map(promotion => ({
        '@type': 'Product',
        name: promotion.title,
        url: `${domain.value}${getPath({ componentName: 'Promotion', slug: promotion.slug })}`,
        brand: { '@id': `${domain.value}/#organization` },
        offers: promotion.priceOfDiscounted && promotion.priceOfDiscounted < promotion.price
          ? {
              '@type': 'AggregateOffer',
              lowPrice: promotion.priceOfDiscounted || 0,
              highPrice: promotion.price || 0,
              priceCurrency: currencyName.value,
              availability: 'https://schema.org/InStock',
              url: `${domain.value}${getPath({ componentName: 'Promotion', slug: promotion.slug })}`,
            }
          : {
              '@type': 'Offer',
              price: promotion.price || 0,
              priceCurrency: currencyName.value,
              availability: 'https://schema.org/InStock',
              url: `${domain.value}${getPath({ componentName: 'Promotion', slug: promotion.slug })}`,
            },
      })),
    }),
  ]))

  return {
    asyncCategory,
    breadcrumbs,
    promotions,
    page,
    perPage,
    total,
    getPath,
    eventPromotion,
  }
}
